import dayjs, { Dayjs } from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

export enum Inclusion {
  IncludeBoth = '[]',
  ExcludeBoth = '()',
  IncludeStartDate = '[)',
  IncludeEndDate = '(]'
}

type Granularity = null | 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second' | 'millisecond'

type DateT = Date | Dayjs

export const isWithinRange = (
  dateToCheck: Dayjs,
  startDate: DateT,
  endDate: DateT,
  inclusion: Inclusion,
  granularity: Granularity = null
) => dateToCheck.isBetween(startDate, endDate, granularity, inclusion)
